import { cn, ModeToggle, Separator, SidebarTrigger } from "@devhop/ui";
import { useEffect, useState } from "react";
import { ProfileDropdown } from "@/modules/auth/presentation/ui/ProfileDropdown";
import { Breadcrumbs } from "./Breadcrumbs";

type HeaderProps = React.HTMLAttributes<HTMLElement> & {
  fixed?: boolean;
  ref?: React.Ref<HTMLElement>;
  /** ຖ້າ true ບໍ່ສະແດງ breadcrumb (ໃຊ້ເມື່ອສົ່ງ children ແທນເຕັມ) */
  hideBreadcrumb?: boolean;
};

export function Header({
  className,
  fixed,
  children,
  hideBreadcrumb = false,
  ...props
}: HeaderProps) {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      setOffset(document.body.scrollTop || document.documentElement.scrollTop);
    };

    document.addEventListener("scroll", onScroll, { passive: true });

    return () => document.removeEventListener("scroll", onScroll);
  }, []);

  const showBreadcrumb = !hideBreadcrumb;

  return (
    <header
      className={cn(
        "z-50 h-16",
        fixed && "header-fixed peer/header sticky top-0 w-[inherit]",
        offset > 10 && fixed ? "shadow" : "shadow-none",
        className,
      )}
      {...props}
    >
      <div
        className={cn(
          "relative flex h-full items-center gap-3 p-4 sm:gap-4",
          offset > 10 &&
            fixed &&
            "after:absolute after:inset-0 after:-z-10 after:bg-background/20 after:backdrop-blur-lg",
        )}
      >
        <SidebarTrigger variant="outline" className="max-md:scale-125" />
        <Separator orientation="vertical" className="h-6" />

        <div className="flex min-w-0 flex-1 items-center gap-3">
          {showBreadcrumb ? <Breadcrumbs /> : null}
          {children ? (
            <>
              {showBreadcrumb ? (
                <Separator
                  orientation="vertical"
                  className="hidden h-6 shrink-0 md:block"
                />
              ) : null}
              <div className="flex min-w-0 flex-wrap items-center gap-2">
                {children}
              </div>
            </>
          ) : null}
        </div>

        <div className="ms-auto flex shrink-0 items-center space-x-4">
          <ModeToggle />
          <ProfileDropdown />
        </div>
      </div>
    </header>
  );
}
